import { useEffect, useState } from 'react';

import { callApi } from 'Core/services/api';

const fetchUserConsultations = async () => callApi("/my-consultations");

export const useUserConsultations = () => {
  const [consultations, setConsultations] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchApi = async () => {
      const { response } = await fetchUserConsultations();
      setConsultations(response);
      setIsLoading(false);
    };

    fetchApi();
  }, []);

  return { consultations, isLoading };
};
